"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withCriticalFeature = void 0;
const react_1 = require("react");
const react_2 = __importDefault(require("react"));
const monera_app_core_1 = require("@amzn/monera-app-core");
function withCriticalFeature(Component) {
    return (hocProps) => {
        (0, react_1.useEffect)(() => {
            monera_app_core_1.csm.emitCriticalFeatureMetric();
        }, [monera_app_core_1.csm.getScope()]);
        return react_2.default.createElement(Component, Object.assign({}, hocProps));
    };
}
exports.withCriticalFeature = withCriticalFeature;
